<template>
	<div class="row">
		<Navbar style="display: none" />
		<div class="pdfViewer col-12" v-if="pdfUrl">
			<div class="text-center">
				<!--<object class="pdf-page" :data="pdfSource" id="pdfEmbed" type="application/pdf" ref="pdfEmbed" style="display: none;"></object>-->
				<iframe class="pdf-page" :src="pdfUrl" id="pdfIframe" name="pdfIframe"></iframe>
			</div>
		</div>
		<div class="col-12 text-center center-flex" v-if="!pdfUrl">
			<h1 v-if="message">{{ t(this.message, this.message) }}</h1>
			<h1 v-else>{{ t('viewDocNoFileLoaded', 'viewDocNoFileLoaded') }}</h1>
		</div>
		<div class="row pdf-footer p-2 text-center" v-if="pdfUrl">
			<div class="col-12 text-center">
				<a onclick="parent.history.back(); return false;" style="color: white;" href="#">{{ t('viewDocBackBtn', 'viewDocBackBtn') }}</a><br>
				<button class="btn btn-primary" @click="saveDocument">{{ t('viewDocSaveBtn', 'viewDocSaveBtn') }}</button>
				<button class="btn btn-primary ml-2" v-if="downloadData" @click="downloadDataFile">{{ t('viewDocDownloadData', 'viewDocDownloadData') }}</button>
				<!--
				{if !$module->isCC && $user_reply_button}
				<button class="btn btn-primary" v-if="getUserLevel < 1.00" title='Use this button to reply or raise queries on the above document'>Reply</button>
				-->
				<button class="btn btn-primary ml-2" title='' @click="openEmailModal">{{ t('viewDocEmailBtn', 'viewDocEmailBtn') }}</button>
				<div v-if="getUserLevel >= 1.00" style="display: inline-block;">
					<button class="btn btn-primary ml-2" @click="modalCreator({id: 'faxModal', title: t('documentsSearchFaxModalHead','documentsSearchFaxModalHead'), level: 'main', open: 'open', entries: 'single', type: 'default'},
					docInfo, $event.target)">{{ t('viewDocFaxBtn', 'viewDocFaxBtn') }}</button>
					<button class="btn btn-primary ml-2" @click="sendPostCopy($event.target)">{{ t('viewDocPostBtn', 'viewDocPostBtn') }}</button>
					<!--<button class="btn btn-primary ml-2" disabled>{{ t('viewDocPostBtn', 'viewDocPostBtn') }}</button>-->
				</div>
				<div class="ml-2" v-if="stampConditions" style="display: inline-block;">
					<button class="btn btn-primary" v-if="clientName != 'mtvn'" @click="getFileData('nostamp')">{{ t('viewDocNoStampBtn', 'viewDocNoStampBtn') }}</button>
				</div>
				<div v-if="getUserLevel >= 1.00" style="display: inline-block;">
					<button class="btn btn-primary ml-2" v-if="isDefault" @click="getFileData('default')">{{ t('viewDocDefaultStampBtn', 'viewDocDefaultStampBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isTrueCertified" @click="getFileData('trueandcertified')">{{ t('viewDocTrueCertifiedBtn', 'viewDocTrueCertifiedBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isCopy" @click="getFileData('copy')">{{ t('viewDocCopyStampBtn', 'viewDocCopyStampBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isApproved" @click="getFileData('approved')">{{ t('viewDocApprovedStampBtn', 'viewDocApprovedStampBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isOverdue" @click="getFileData('overdue')">{{ t('viewDocOverdueStampBtn', 'viewDocOverdueStampBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isOverdue2" @click="getFileData('overdue2')">{{ t('viewDocOverdue2StampBtn', 'viewDocOverdue2StampBtn') }}</button>
					<button class="btn btn-primary ml-2" v-if="isDirectDebit && clientName != 'mtvn' && clientName != 'mtvntest'" @click="getFileData('directdebit')">{{ t('viewDocDirectDebitStampBtn', 'viewDocDirectDebitStampBtn') }}</button>
				</div>
				<template v-if="contactDisplaySettings.enableContactSettings && contactDisplaySettings.enableContactSettings.enabled">
					<div v-if="clientName != 'inte' && clientName != 'intetest'" style="display: inline-block;">
						<button v-if="contactDisplaySettings.enableContactSettings.raiseQuery" class="btn btn-primary ml-2" @click="modalCreator({id: 'queryModal', title: t('documentsSearchRaiseQueryModalHead', 'documentsSearchRaiseQueryModalHead'), level: 'main', open: 'open', entries: 'single'},
						{ docsChecked: [docInfo.id], statuses: {docId: docInfo.id, status: docInfo.batch_status, customer: docInfo.customer_ref}, docInfo: { reference: docInfo.reference}}, $event.target)">{{ t('viewDocRaiseQueryBtn', 'viewDocRaiseQueryBtn') }}</button>
						<button v-if="contactDisplaySettings.enableContactSettings.notifyRemittance" class="btn btn-primary ml-2" @click="modalCreator({id: 'notifyModal', title: t('documentsSearchNotifyRemittanceModalHead', 'documentsSearchNotifyRemittanceModalHead'), level: 'main', open: 'open', entries: 'single'},
						{ docsChecked: [docInfo.id], statuses: {docId: docInfo.id, status: docInfo.batch_status, customer: docInfo.customer_ref}, documentDetails: [], docInfo: {
							total_value: docInfo.total_value, reference: docInfo.reference, batch: docInfo.batch}}, $event.target)">{{ t('viewDocNotifyRemittanceBtn', 'viewDocNotifyRemittanceBtn') }}</button>
					</div>
				</template>
				<button v-if="(clientName == 'look' || clientName == 'looktest') && !isPaid" class="btn btn-primary ml-2" @click="modalCreator({id: 'paymentModal', title: t('documentsSearchRaiseQueryModalHead', 'documentsSearchRaiseQueryModalHead'), level: 'main', open: 'open', entries: 'single'}, docId, $event.target)">{{ t('viewDocPayBtn', 'viewDocPayBtn') }}</button>
				<button class="btn btn-primary ml-2" @click="printDocument()">{{ t('viewDocPrintBtn', 'viewDocPrintBtn') }}</button>
				<button class="btn btn-danger ml-2" @click="closeTab()">{{ t('viewDocCloseBtn', 'viewDocCloseBtn') }}</button>
			</div>
		</div>
		<div class="overlay" v-if="overlayActive">
			<loading
				id="widget-loading-spinner"
				class="align-items-center"
				:color="'#047bf8'"
				:loader="'spinner'"
				:active="overlayActive"
				:transition="'fade'"
				:is-full-page="false">
			</loading>
		</div>
		<ModalEmailDoc :modal="this.modal"/>
		<ModalFaxDoc :modal="this.modal"/>
    <ModalPostDoc :modal="this.modal"/>
		<ModalRaiseQuery :modal="(getModalLevel('query') == 'main')? this.modal : this.subModal"/>
		<ModalNotifyRemittance :modal="this.modal"/>
		<ModalPayment :modal="this.modal"/> <!-- NS-9511: DL - Online payments for V3 -->
		<ModalInfoDoc :modal="(getModalLevel('info') == 'main')? this.modal : this.subModal"/>
		<div v-if="this.modal['modalData'].open" class="modal-backdrop show"></div>
	</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import pdf from 'vue-pdf'
import { mapGetters } from 'vuex'
import { clientShortName } from '@/helpers/clientShortName.js'
import Loading from 'vue-loading-overlay'
import { backendUrl } from '@/helpers/backendUrl.js'

import ModalEmailDoc from '@/components/Documents_Search/ModalEmailDoc.vue'
import ModalFaxDoc from '@/components/Documents_Search/ModalFaxDoc.vue'
import ModalPostDoc from '@/components/Documents_Search/ModalPostDoc.vue'
import ModalNotifyRemittance from '@/components/Documents_Search/ModalNotifyRemittance.vue'
import ModalRaiseQuery from '@/components/Documents_Search/ModalRaiseQuery.vue'
import ModalPayment from '@/components/Documents_Search/ModalPayment.vue' //NS-9511: DL - Online payments for V3 
import ModalInfoDoc from '@/components/Documents_Search/ModalInfoDoc.vue'

export default {
	name: 'ViewDocument',
	components: {
		Navbar,
		pdf,
		Loading,
		ModalEmailDoc,
		ModalFaxDoc,
    ModalPostDoc,
		ModalNotifyRemittance,
		ModalInfoDoc,
		ModalRaiseQuery,
		ModalPayment //NS-9511: DL - Online payments for V3 
	},
	provide() {
    return {
      //modal functions
      resetModal: this.resetModal,
      modalCreator: this.modalCreator,
      changeModalLevel: this.changeModalLevel,
      getModalLevel: this.getModalLevel,
      subModal: this.subModal,
	    searchDocuments: this.searchDocuments,

    }
  },
	data() {
		return {
			src: null,
			response: null,
			pdfData: null,
			overlayActive: false,
			filename: '',
			downloadData: null,
			stampConditions: null,
			isDefault: null,
			isTrueCertified: null,
			isCopy: null,
			isApproved: null,
			isOverdue: null,
			isOverdue2: null,
			isDirectDebit: null,
			isPaid: null,
			fileData: null,
			pdfSource: '',
			pdfUrl: '',
			//Data storage for the modals
			modal: {
				modalData: {},
				docuData: {},
				updateData: {}
			},
			subModal: {
				modalData: {},
				docuData: {},
				itemData: {},
				updateData: {}
			},
			currentStamp: 'nostamp',
			message: null
		}
	},
	methods: {
    sendPostCopy(target) {
      // format the data so it can be supported
      // EIPP-577 reused the seleted array functionality here. to remove some common code.
      this.modalCreator({id: 'postModal', title: this.t('documentsSearchPostModalHead', 'documentsSearchPostModalHead'), level: 'main', open: 'open', entries: 'single', type: 'default'}, this.getSelectedArray(), target)
    },

		searchDocuments() {

		},
		saveDocument() {
			this.downloadPDF(this.pdfData)
		},
		printDocument() {
			// EIPP-556 Change to print function, PW
			let blob = this.convertToBlob(this.pdfData)
			let blobURL = URL.createObjectURL(blob)
			let iframe =  document.createElement('iframe') //load content in an iframe to print later
			document.body.appendChild(iframe)

			iframe.style.display = 'none';
			iframe.src = blobURL;
			iframe.onload = function() {
				setTimeout(function() {
					iframe.focus();
					iframe.contentWindow.print()
				}, 1);
			};
		},
		downloadPDF(pdf) {
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				let blob = this.convertToBlob(pdf)
				window.navigator.msSaveBlob(blob, this.filename)
			} else {
				const linkSource = `data:application/pdf;base64,${pdf}`;
				const downloadLink = document.createElement("a");
				const fileName = this.filename;

				downloadLink.href = linkSource;
				downloadLink.download = fileName;
				downloadLink.click();
			}
		},
		downloadDataFile() {
			this.overlayActive = true
			this.$store.dispatch("documentsStore/downloadDataFile", this.$route.params).then(response => {
				const linkSource = `data:application/` + response.extension + `;base64,${response.mappedData.data}`
				const downloadLink = document.createElement("a")
				const fileName = response.mappedData.filename

				downloadLink.href = linkSource
				downloadLink.download = fileName
				downloadLink.click()

				this.overlayActive = false
			})
		},
		convertToBlob(pdfData) {
			var byteCharacters = atob(pdfData);
			var byteNumbers = new Array(byteCharacters.length);
			for (var i = 0; i < byteCharacters.length; i++) {
				byteNumbers[i] = byteCharacters.charCodeAt(i);
			}
			var byteArray = new Uint8Array(byteNumbers);
			var blob = new Blob([byteArray], {type: 'application/pdf'});

			return blob
		},
		closeTab() {
			self.close()
		},
		getFileData(stamp = 'none') {
			let data = this.$route.params
			data.stamp = stamp
			this.overlayActive = true

			this.$store.dispatch("documentsStore/getDocumentData", data).then(response => {
				if(response && response.status == 'error') {
					this.pdfData = false
					this.overlayActive = false
					this.message = response.key
				} else {
					this.pdfData = response.pdfData
					this.filename = response.filename
					this.downloadData = response.downloadData
					this.stampConditions = response.stampConditions
					this.isPaid = response.isPaid
					//this.pdfUrl = backendUrl() + '/viewDocument/' + this.$route.params.id + '/' + stamp + '/' + this.$route.params.type + '/' + response.docToken

					//this.pdfSource = 'data:application/pdf;headers=filename%3D' + response.filename + ';base64,'+ response.pdfData
					//this.pdfUrl = pdfUrl
					// NS-9771, the iframe will now receive a url to backend that will render it, that change was needed to add controllable filename in download functionality, PW
					this.pdfUrl = backendUrl() + response.documentUrl

					if(response.stampConditions) {
						this.isDefault = response.stampConditions.path_to_default
						this.isCopy = response.stampConditions.path_to_copy
						this.isTrueCertified = response.stampConditions.path_to_trueandcertified
						this.isApproved = response.stampConditions.path_to_approved
						this.isOverdue = response.stampConditions.path_to_user1
						this.isOverdue2 = response.stampConditions.path_to_user2
						this.isDirectDebit = response.stampConditions.path_to_user1
					}

					this.overlayActive = false
					this.currentStamp = stamp
				}
			})

		},
		//MODALS
		modalCreator(modalData, docuData, button) {

			if(modalData.level == 'main') {
				this.modal.modalData = modalData
				this.modal.docuData = { ...docuData }

				if(modalData.id == 'paymentModal') {
					this.modal.docuData.docsChecked = this.docId
				}

				this.$root.$emit('bv::show::modal', this.modal.modalData.id, button)
			}
			if(modalData.level == 'sub') {
				this.subModal.modalData = modalData
				this.subModal.docuData = { ...docuData }
				this.$root.$emit('bv::show::modal', this.subModal.modalData.id, button)
			}

		},
		resetModal(level, button = '') {
			if(level == 'main') {
				Object.keys(this.modal['modalData']).forEach((key) => (key === 'id') ? this.modal['modalData'][key] : (this.modal['modalData'][key] = '' ))
				Object.keys(this.modal['docuData']).forEach((key) => (this.modal['docuData'][key] = '' ))
				Object.keys(this.modal['updateData']).forEach((key) => (this.modal['updateData'][key] = '' ))
				this.$store.dispatch('alertClearResponse')
			}
			if(level == 'sub') {
				Object.keys(this.subModal['modalData']).forEach((key) => (key === 'id') ? this.subModal['modalData'][key] : (this.subModal['modalData'][key] = '' ))
				Object.keys(this.subModal['docuData']).forEach((key) => (this.subModal['docuData'][key] = '' ))
				Object.keys(this.subModal['updateData']).forEach((key) => (this.subModal['updateData'][key] = '' ))
				this.$store.dispatch('alertClearResponse')
			}
		},
		changeModalLevel(modal, level) {
			switch (modal) {
				case 'query':
					this.modalLevelQuery = level
					break;
				default:
					break;
			}
		},
		getModalLevel(modal) {
			switch (modal) {
				case 'query':
					return this.modalLevelQuery
					break;
				default:
					break;
			}
		},
    //EIPP-577 added a get selected array function which simulates the selection array like in the manage batches.
    getSelectedArray(){
      let docArray = []
      docArray.docsChecked = []
      docArray['docsChecked'].push(this.docInfo.id)
      return docArray;
    },
    //EIPP-577 added a separate function to open the email modal and passing the seleted document data.
    openEmailModal(event){
      this.modalCreator({
            id: 'emailModal',
            title: this.t('documentsSearchEmailModalHead','documentsSearchEmailModalHead'),
            level: 'main',
            open: 'open',
            entries: 'single',
            wm: (this.currentStamp == 'nostamp')? 'none' : this.currentStamp,
            perm_wm_allowed: (this.currentStamp == 'nostamp')? true :false},
          this.getSelectedArray(),
          event.target )
    },
	},
	created(){
		this.getFileData()
		this.$store.dispatch("documentsStore/getDocumentInfo", {id: this.docId})
		this.$store.dispatch("documentsStore/getContactDisplaySettings")
		document.getElementsByTagName('body')[0].style.overflow = 'hidden'
		this.modalLevelQuery = 'main'
		this.modalLevelInfo = 'main'
	},
	computed: {
		...mapGetters(['getUserLevel']),
		...mapGetters('documentsStore',['getCoversheetPdf']),
		clientName() {
			let clientName = clientShortName()
			return clientName
		},
		docId() {
			return this.$route.params.id
		},
		docType() {
			return this.$route.params.type
		},
		docInfo(){
			return this.$store.getters['documentsStore/getDocumentInfo']
		},
		contactDisplaySettings(){
			return this.$store.getters['documentsStore/getContactDisplaySettings']
		}
	}
}

</script>

<style scoped>

[v-cloak] {
	display: none !important;
}

.pdf-footer {
	position: fixed;
  	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	background-color: #5c5c5c;
}

.overlay {
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
	background-color: #5c5c5c;
	position: fixed;
	z-index: 000;
}

.pdf-page {
	display: inline-block;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	height: 90vh;
	padding: 0px;
}

.center-flex {
	display: flex;
	justify-content: center;
	align-items: center;
}

</style>
